<app-accordion title="About">
  <div class="content">
    <div>
      <div class="category-label">Feedback</div>
      <div class="section bordered">
        <div class="text">
          Please select a category for your feedback and provide as much detail
          as possible. Click "Create" to open your email application and attach
          any relevant screenshots or videos before sending.
        </div>
        <app-button
          icon="pi pi-envelope"
          class="width-100"
          style="margin-top: 0.5rem"
          label="Feedback"
          [outlined]="true"
          (click)="feedbackVisible = true"
        />
        <app-feedback-overlay [(visible)]="feedbackVisible" />
      </div>
    </div>
    <!-- <app-known-issues class="width-100" /> -->
    <app-versions class="width-100" />
    <div class="section gap-05">
      @if (globalService.theme() === "light") {
        <img
          class="image"
          src="../../../../../assets/light/APA_Logo.svg"
          alt="APA_Logo"
        />
      } @else {
        <img
          class="image"
          src="../../../../../assets/dark/APA_Logo.svg"
          alt="APA_Logo"
        />
      }
      <div class="version">Sequence History Version {{ version }}</div>
    </div>
  </div>
</app-accordion>
